import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { getUserState } from "../../app/selector";

import { Header } from "./Header";
import GDPRPopup from "./GDPRPopup";
import Footer from "./footer/Footer";
import Navigation from "./Navigation";
import Registration from "../home/Registration";

const Layout = () => {
  const { loggedIn } = useSelector(getUserState);

  return (
    <div className="app-container">
      <Header />

      <main className="content">
        <div className="main-content-area">
          <Outlet />
        </div>

        <aside className="sidebar-panel">
          {loggedIn ? <Navigation /> : <Registration />}
        </aside>
      </main>

      <Footer />
      <GDPRPopup />
    </div>
  );
};

export default Layout;